// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as City$PorterinFeature from "../../../../../shared/core/helpers/City.mjs";
import * as LatLng$PorterinFeature from "../../../domain/entity/LatLng.mjs";
import * as CityConfig$PorterinFeature from "../../../../partners/domain/repo/types/CityConfig.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as Requirement$PorterinFeature from "../../../../../shared/core/domain/entities/Requirement.mjs";
import * as FeParamsHelper$PorterinFeature from "../../../../../shared/core/helpers/FeParamsHelper.mjs";
import * as GetFareEstimateV1$PorterinFeature from "../../../domain/helpers/GetFareEstimateV1.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../domain/store/FareEstimateStoreV1.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as FareEstimateHelperV1$PorterinFeature from "../../../domain/repo/FareEstimateHelperV1.mjs";
import * as FareEstimateEventHelper$PorterinFeature from "../../../domain/helpers/FareEstimateEventHelper.mjs";
import * as FareEstimateResultStoreEn$PorterinFeature from "../../../../../shared/core/constants/FareEstimateResultStoreEn.mjs";
import * as FareEstimateResultFormHelperV1$PorterinFeature from "../../../domain/helpers/FareEstimateResultFormHelperV1.mjs";

function initialFormState(query_params) {
  return {
          pickup_address: {
            landmark: FareEstimateResultFormHelperV1$PorterinFeature.getLandmarkLocation(query_params.from_address_landmark),
            location: {
              lat: FareEstimateResultFormHelperV1$PorterinFeature.getLocationCoordinates(query_params.from_address_lat),
              lng: FareEstimateResultFormHelperV1$PorterinFeature.getLocationCoordinates(query_params.from_address_long)
            }
          },
          drop_address: {
            landmark: FareEstimateResultFormHelperV1$PorterinFeature.getLandmarkLocation(query_params.to_address_landmark),
            location: {
              lat: FareEstimateResultFormHelperV1$PorterinFeature.getLocationCoordinates(query_params.to_address_lat),
              lng: FareEstimateResultFormHelperV1$PorterinFeature.getLocationCoordinates(query_params.to_address_long)
            }
          },
          category: Belt_Option.getWithDefault(query_params.service_category, FareEstimateResultStoreEn$PorterinFeature.service_category_trucks)
        };
}

function initialFormStateV2(query_params) {
  return {
          pickup_address: {
            landmark: "",
            location: LatLng$PorterinFeature.initial_lat_lng(undefined)
          },
          drop_address: {
            landmark: "",
            location: LatLng$PorterinFeature.initial_lat_lng(undefined)
          },
          category: Belt_Option.getWithDefault(query_params.service_category, FareEstimateResultStoreEn$PorterinFeature.service_category_trucks)
        };
}

function onFormSubmit(set_is_serviceable_dropoffOpt, set_is_serviceable_pickupOpt, output, callbacks, query_params, recaptcha_execute, setPreviousResponse, category, isDesktop, recaptcha_context, is_v2) {
  var set_is_serviceable_dropoff = set_is_serviceable_dropoffOpt !== undefined ? set_is_serviceable_dropoffOpt : (function (param) {
        
      });
  var set_is_serviceable_pickup = set_is_serviceable_pickupOpt !== undefined ? set_is_serviceable_pickupOpt : (function (param) {
        
      });
  var form_data = FareEstimateHelperV1$PorterinFeature.toApiInput({
        TAG: /* TrucksForm */1,
        _0: {
          pickup_address: output.pickup_address,
          drop_address: output.drop_address,
          name: Belt_Option.getWithDefault(query_params.customer_name, ""),
          mobile: Belt_Option.getWithDefault(query_params.customer_mobile, ""),
          requirement: Requirement$PorterinFeature.requirementfromString(Belt_Option.getWithDefault(query_params.frequency, "personal")),
          service_category: Belt_Option.getWithDefault(query_params.service_category, FareEstimateResultStoreEn$PorterinFeature.service_category_trucks)
        }
      }, undefined, undefined);
  PublishEventsHelper$PorterinFeature.publishEvents(category, FareEstimateStoreV1$PorterinFeature.ga_fare_estimate_form_validation, "" + category + "_" + form_data.service_category + "_" + form_data.mobile + "");
  Js_promise.$$catch((function (error) {
          Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "FareEstimateResults - " + error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (validator_response) {
              if (validator_response.TAG === /* Ok */0) {
                var match = validator_response._0;
                var redirect_url = match.redirect_url;
                var geo_region = FareEstimateHelperV1$PorterinFeature.getParamValue(redirect_url, "geo_region_id", City$PorterinFeature.cityToGeoRegionId(CityConfig$PorterinFeature.bangalore).toString());
                var updated_form_data_pickup_address = form_data.pickup_address;
                var updated_form_data_drop_address = form_data.drop_address;
                var updated_form_data_name = form_data.name;
                var updated_form_data_mobile = form_data.mobile;
                var updated_form_data_requirement = form_data.requirement;
                var updated_form_data_service_category = form_data.service_category;
                var updated_form_data = {
                  geo_region: geo_region,
                  pickup_address: updated_form_data_pickup_address,
                  drop_address: updated_form_data_drop_address,
                  name: updated_form_data_name,
                  mobile: updated_form_data_mobile,
                  requirement: updated_form_data_requirement,
                  service_category: updated_form_data_service_category
                };
                var redirect_url_with_cb_data = redirect_url + FareEstimateHelperV1$PorterinFeature.makeCallbackDataQueryParams(match.callback_request_data);
                var validator_response$1 = FareEstimateHelperV1$PorterinFeature.updateRedirectUrl(validator_response, redirect_url_with_cb_data);
                Js_promise.$$catch((function (error) {
                        Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "FareEstimateResults Hash - " + error.toString());
                        return Promise.resolve(undefined);
                      }), Js_promise.then_((function (estimate_secure_response) {
                            if (estimate_secure_response.TAG === /* Ok */0) {
                              var final_redirect_url = estimate_secure_response._0;
                              Curry._1(setPreviousResponse, (function (param) {
                                      return FareEstimateHelperV1$PorterinFeature.updateRedirectUrl(validator_response$1, final_redirect_url);
                                    }));
                              Curry._1(callbacks.notifyOnSuccess, undefined);
                              var url = is_v2 ? FareEstimateHelperV1$PorterinFeature.fareEstimateV2RedirectUrl(final_redirect_url, form_data.service_category, "Fare Estimate Edit/Retry", isDesktop) : FareEstimateHelperV1$PorterinFeature.fareEstimateResultRedirectUrlEdit(final_redirect_url, form_data.service_category, "Fare Estimate Edit/Retry", isDesktop);
                              FeParamsHelper$PorterinFeature.saveToStoreAndRedirect(url, "FareEstimateResults");
                            } else {
                              Curry._1(setPreviousResponse, (function (param) {
                                      return estimate_secure_response;
                                    }));
                              Curry._1(callbacks.notifyOnFailure, estimate_secure_response._0);
                            }
                            return Promise.resolve(undefined);
                          }), GetFareEstimateV1$PorterinFeature.getFareEstimateHash(redirect_url_with_cb_data, updated_form_data, recaptcha_execute, recaptcha_context)));
              } else {
                var error = validator_response._0;
                FareEstimateEventHelper$PorterinFeature.publishFareEstimateFormErrorParameterV2(error);
                if (is_v2 && error.TAG !== /* FareEstimateHashError */0) {
                  var val = error._0.field_errors;
                  if (val !== undefined) {
                    if (Belt_Option.isSome(val.pickup)) {
                      Curry._1(set_is_serviceable_pickup, false);
                    }
                    if (Belt_Option.isSome(val.drop)) {
                      Curry._1(set_is_serviceable_dropoff, false);
                    }
                    
                  }
                  
                }
                Curry._1(setPreviousResponse, (function (param) {
                        return validator_response;
                      }));
                Curry._1(callbacks.notifyOnFailure, error);
              }
              return Promise.resolve(undefined);
            }), GetFareEstimateV1$PorterinFeature.getFareEstimate(form_data, form_data.service_category, isDesktop, "Fare Estimate Edit/Retry", recaptcha_execute, recaptcha_context)));
}

export {
  initialFormState ,
  initialFormStateV2 ,
  onFormSubmit ,
}
/* City-PorterinFeature Not a pure module */
